"use client";
import { cn } from "@/lib";
import { useAppStore } from "@/store/general";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import { routes } from "@/routes";

const SplitButton = () => {
  const t = useTranslations();
  const pathname = usePathname();
  const { setPreviousPath } = useAppStore();
  const handleLinkClick = () => {
    if (pathname) {
      setPreviousPath(pathname);
    }
  };

  return (
    <button
      id="app-header-login"
      className={cn(
        "group shadow-[inset_0_0_0_0_theme(colors.primary.main)] ease hover:shadow-[inset_0_-100px_0_0_theme(colors.primary.main)] h-max w-max overflow-hidden rounded-xl border border-white text-white transition duration-500",
      )}
    >
      <Link
        title={t("header.login")}
        href={routes.auth.SEND_OTP.primaryPath}
        onClick={handleLinkClick}
        className="flex"
      >
        <div
          className={cn(
            "cursor-pointer border-l border-l-white p-1 px-4 text-sm transition-colors xl:text-base",
          )}
        >
          {t("header.login")}
        </div>
        <div
          className={cn(
            "cursor-pointer p-1 px-4 text-sm transition-colors xl:text-base",
          )}
        >
          {t("header.signup")}
        </div>
      </Link>
    </button>
  );
};

export default SplitButton;
